// extracted by mini-css-extract-plugin
export default {"root":"Header_root__nXgNz","trigger":"Header_trigger__8H+jc"};